import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import SearchSvg from '../../svg/admin/Search';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { fetchSchoolMissions, teacherUpdateSchoolMission } from '../../services2/schoolMissions.service';
import { useSetting } from '../../util/useSetting';

const RESEARCHES = [
       { 
    id: '100',
    name: 'Pilot Test',
    image: '/secondary/tasks/11.png',
    subtitle: '研究測試 Pilot Test',
    link: '/platform2/research-practices/preview/100'
  },
  { 
    id: '1',
    name: '香港學生睡眠',
    image: '/secondary/tasks/r1.png',
    subtitle: '研究測試 A-1'
  },
  {
    id: '2',
    name: '機器人',
    image: '/secondary/tasks/r2.png',
    subtitle: '研究測試 A-2'
  },
  { 
    id: '3',
    name: '小販文化',
    image: '/secondary/tasks/p1.png',
    subtitle: '研究測試 B-1'
  },
  {
    id: '4',
    name: '香港學生運動',
    image: '/secondary/tasks/p2.png',
    subtitle: '研究測試 B-2'
  },
  { 
    id: '5',
    name: '孤獨感',
    image: '/secondary/tasks/p3.png',
    subtitle: '研究測試 C-1'
  },
  {
    id: '6',
    name: '香港氣候變化',
    image: '/secondary/tasks/p4.png',
    subtitle: '研究測試 C-2'
  },

]

function Component(props) {
    const { } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(RESEARCHES)
    const [isLoading, setisLoading] = useState(false)
    const [total, settotal] = useState(data.length)
    const { fontSize } = useSetting();


    const filter = searchParams.get('filter') || '全部';
    const status = searchParams.get('status') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit = 10
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    const handleUpdateStatus = (newValue) => {
        searchParams.delete('status')
        searchParams.set('status', newValue)
        setSearchParams(searchParams)
    }

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        // let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        // if (result.result) {
        //     setdata(result.result)
        //     settotal(result.count || 0)
        // } else {
        //     alert('Fetch data error')
        // }
        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(fetchData, 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])



    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex p-[16px] gap-[16px]' style={{ fontSize, backgroundImage: `url('/secondary/bg7.png')`,backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-col items-start justify-start gap-[16px]'>
                <div className='text-[#4B555C] font-[700] cursor-pointer' style={{fontSize:fontSize}} onClick={() => {navigate('/platform2')}}>{'< 返回首頁'}</div>
                <div className='text-[#4B555C] font-[900] ' style={{fontSize:fontSize+4}}>全部研究測試</div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*list of data*/}
            <div className='flex flex-row w-full flex-wrap px-[16px] justify-between items-stretch p-[16px] font-[600] overflow-auto'>
                {data?.map((item, index) =>
                    <button key={item?._id} className='flex flex-col justify-start items-start relative rounded-[16px] mt-[16px] min-w-[400px] ' style={{ boxShadow: '0 4px 6px rgba(0,0,0,0.1)',background:'linear-gradient(to left, #178E95, #07162F)',width:'calc(50% - 8px)' }}
                        onClick={() => {navigate(`/platform2/research-practices/preview/${item?.id}`)}}
                    >
                        <div className='text-white font-[900] px-[16px] py-[8px]'>{item?.subtitle}</div>
                        <div className='relaticve w-full rounded-[16px] overflow-hidden bg-[white] flex flex-col h-full'  style={{ height:undefined,aspectRatio: '76/34', backgroundImage: `url(${item?.image})`, backgroundSize: 'cover', backgroundPosition: 'center',}}>
                            <div className='absolute bottom-0 left-0 right-0 h-[60%] z-[1] rounded-[16px] overflow-hidden' style={{ background: 'linear-gradient(to top, rgba(255,255,255,1),rgba(255,255,255,1), rgba(0,0,0,0))' }} />
                            <div className='flex-1 w-full flex flex-row items-end z-[2]'>
                                <div className='flex-1 flex flex-col justify-end items-start p-[16px] gap-[16px]'>
                                    <div style={{fontSize: fontSize + 2}}>{item?.name}</div>
                                    <div style={{fontSize: fontSize}}>{item?.subtitle}</div>
                                </div>
                            </div>
                        </div>
                    </button>
                )}
               
            </div>
            {/*end of list of data*/}
            <PageSelector
                handleSelectPage={handleSelectPage}
                page={page}
                total={total}
                totalPage={totalPage}
            />
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
